import { CodingRoute } from './lib/components/coding-tool/coding-route';
import { DocumentsLink } from './lib/components/common/navigation';

import { CodeBooks } from './lib/components/trucode/code-books';

import { history, Router } from './lib/core/router';
import { TruCode } from './lib/core/trucode';
import { loadVisitById } from './lib/core/visit-context';
import { workflows } from './lib/core/workflow-api';
import { WorkflowsDialogue } from './lib/core/workflows';

import { Navigate, Route, Routes } from 'react-router';
import './App.css';
import { userProfileApi } from './lib/api/user-profile-api';
import { AppContext } from './lib/common/app-context';
import { SecureRoute } from './lib/common/secure-route';
import { setPendingWorkflow } from './lib/components/coding-list/visit-list-api-activity';
import { AuditReviewPageRoute, codingVisitsApiActivity, VisitPageRouteActivity } from './lib/components/coding-list/visit-page-activity';
import { EmptyLoadingPage } from './lib/components/common/presentation';
import { auth, getStoredOrgUrlParams, log } from './lib/core';
import { DocumentsRoute2 } from './lib/core/document-viewer/document-components';
import { documentApi2 } from './lib/core/document-viewer/document-api';

window.onload = () => {
  // A value of 1 indicates a classic 96 DPI (76 DPI on some platforms) display, while a value of 2 is expected for HiDPI/Retina displays
  console.info('window.devicePixelRatio', window.devicePixelRatio);

  if (window.devicePixelRatio === 2 && navigator.userAgent.indexOf('Win') !== -1) {
    (document.body.style as any).zoom = 0.9;
  } else {
    (document.body.style as any).zoom = 1;
  }
};

export const params = getStoredOrgUrlParams();
const { organizationCode, locationCode, departmentCode, workflow, visitId, activity, worksheetId } = params || {};

const isAuditReview = activity === 'AUDITREVIEW' || window.location.href.indexOf('/audit') > -1;

const isDocuments = window.location.href.indexOf('/documents') > -1;
const isSearch = window.location.href.indexOf('/search') > -1;

function loadWorkflow(workflow: string, complete?: () => void) {
  const args: any = {
    activity,
    workflow,
    location: locationCode,
    department: departmentCode || 'ED',
  };

  if (activity) {
    setPendingWorkflow(true);

    if (visitId) {
      workflows.actions.load(args).then(() => complete && complete());
    } else {
      workflows.actions.load(args).then(() => complete && complete());
    }
  } else {
    console.info('No activity provided during page load.');
  }

  if (organizationCode) {
    codingVisitsApiActivity.org.getState().setSelectionByCode(organizationCode, locationCode, departmentCode);
  }
}

async function init() {
  await codingVisitsApiActivity.org.getState().loadOrganizations(activity);
  const orgs = codingVisitsApiActivity.org.getState().organizations;

  if (!orgs.length) {
    alert('No organizations loaded');
  }

  workflows.data.setState({ initialWorkflow: workflow });

  auth.signedIn = userProfileApi.data.getState().user;
  window.console.info('auth.signedIn ', auth.signedIn);

  if (auth.signedIn) {
    const { firstName, lastName, email } = auth.signedIn;
    log.setUser({ firstName, lastName, email });
  }

  if (!isDocuments && !isSearch) {
    if (visitId) {
      loadWorkflow('auditStd', () => {
        loadVisitById(params.visitId, true, worksheetId);
      });
    } else if (organizationCode) {
      loadWorkflow(workflow || (isAuditReview ? 'auditStd' : workflows.data.getState().initialWorkflow), () => {
        history.push(isAuditReview ? '/audit' : '/list');
      });
    } else {
      codingVisitsApiActivity.org.setState({ promptOrg: true });
    }
  }
}

function signOut() {
  auth.signOut();
}

export function AppActivity() {
  return (
    <AppContext idleTimeout onAuthorized={() => init()} onSignOut={() => documentApi2.closeWindow()}>
      <Router>
        <Routes>
          <Route
            path="/list"
            element={
              <SecureRoute exact path="/list">
                <WorkflowsDialogue />
                <VisitPageRouteActivity signOut={signOut} activity={activity} />
              </SecureRoute>
            }
          />
          <Route
            path="/audit" //audit path
            element={
              <SecureRoute exact path="/audit">
                <WorkflowsDialogue />
                <AuditReviewPageRoute signOut={signOut} />
              </SecureRoute>
            }
          />

          <Route
            path="/documents"
            element={
              <SecureRoute exact path="/documents">
                <DocumentsRoute2 />
              </SecureRoute>
            }
          />

          <Route
            path="/tool"
            element={
              <SecureRoute exact path="/tool" noRedirect={true}>
                <WorkflowsDialogue />
                <TruCode />
                <CodingRoute />
              </SecureRoute>
            }
          />

          <Route
            path="/search"
            element={
              <SecureRoute exact path="/search">
                <CodeBooks />
              </SecureRoute>
            }
          />

          <Route path="/visit" element={<EmptyLoadingPage />} />
          <Route path="/" element={<Navigate replace to="/list" />} />
        </Routes>
      </Router>
      <DocumentsLink hide={true} />
    </AppContext>
  );
}
